/* src/app/features/limite-pagamento-ecg-por-terceiros/cadastro/limite-pagamento-ecg-por-terceiros-cadastro.component.scss */
label {
  font-weight: bold;
}
/*# sourceMappingURL=limite-pagamento-ecg-por-terceiros-cadastro.component.css.map */
